import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FlyingChipProps } from '../../components/ChipSelector/FlyingChips';

type FlyingChip = FlyingChipProps;

type FlyingChipsState = {
    chips: FlyingChip[];
}

const initialState: FlyingChipsState = { chips: [] };

type RemoveFlyingChipPayload = {
    id: string
};

type AddFlyingChipPayload = FlyingChip[];

const flyingChipsSlice = createSlice({
  name: 'flyingChips',
  initialState,
  reducers: {
    addFlyingChips(
      state: FlyingChipsState,
      { payload } : PayloadAction<AddFlyingChipPayload>
    ) {
      return {
        ...state,
        chips: [ ...state.chips, ...payload ],
      };
    },
    removeFlyingChip(
      state: FlyingChipsState,
      { payload }: PayloadAction<RemoveFlyingChipPayload>
    ) {
      return {
        ...state,
        chips: state.chips.filter((el) => el.id !== payload.id),
      };
    },
    removeAllFlyingChips() {
      return {
        chips: [],
      };
    },
  },
});

export const flyingChipsActions = flyingChipsSlice.actions;
export default flyingChipsSlice.reducer;
